import { CORE_FONTS } from './tokens';
import { fontOrDefault, isDisplayFont } from './resolve';

const GOOGLE_FONTS_ORIGIN = 'https://fonts.googleapis.com';
const INTER = CORE_FONTS[0];

/** The selected family, plus Inter when a display font sends body copy to it. */
export function fontQueriesFor(fontId: string | null | undefined): string[] {
  const font = fontOrDefault(fontId);
  if (font.id === INTER.id) return [INTER.query];
  return isDisplayFont(font.id) ? [font.query, INTER.query] : [font.query];
}

/**
 * `swap` rather than `optional`: no text paints before React mounts, so there is
 * nothing to swap, and a missed `optional` window drops the brand font entirely.
 */
export function googleFontsHref(fontId: string | null | undefined): string {
  const families = fontQueriesFor(fontId)
    .map(q => `family=${q}`)
    .join('&');
  return `${GOOGLE_FONTS_ORIGIN}/css2?${families}&display=swap`;
}
